<template>
  <template v-if="profile && product">
    <card-with-slidedown title="Employee Details" :color="employeePercent >= 100 ? '#a0c41c' : '#f69641'" :additional="employeePercent + '%'" :render-open="true" :toggle-closed="employeePercent >= 100">
      <employee-block :profile="profile" :product="product" @employee-saved="$emit('employee-saved', $event)" @percent-updated="onEmployeePercentUpdated"/>
    </card-with-slidedown>

    <card-with-slidedown :title="driversHeader" :color="driversAveragePercent >= 100 ? '#a0c41c' : '#f69641'" :additional="driversAveragePercent + '%'" :render-open="true" :toggle-closed="driversAveragePercent >= 100">
      <p v-if="driversDescription">{{ driversDescription }}</p>

      <div class="driver-list-header">
        <h5>Driver list</h5>
        <button v-if="canAddAdditionalDriver" class="button button--light button--small" @click="$emit('add-driver')">+ ADD ADDITIONAL DRIVER</button>
      </div>

      <div class="driver-blocks">
        <div class="driver-block">
          <div class="driver-header">
            <div class="driver-info">
              <span class="driver-name">{{ profile.forename }} {{ profile.surname }}</span>
              <span class="driver-email">{{ profile.email }}</span>
            </div>
            <div v-if="profile.mainDriver" class="driver-actions">
              <span class="main-driver-pill">Main Driver</span>
            </div>
          </div>
        </div>

        <driver-block v-for="(driver, index) in profile.additionalDrivers" :key="index" :driver="driver" :product="product" :start-open="!driver.additionalDriverID"
          @driver-saved="(apiData) => $emit('driver-saved', { index, apiData })" @driver-deleted="(data) => $emit('driver-deleted', { index, profileData: data?.profile ?? null })" @percent-updated="(val) => onDriverPercentUpdated(index, val)"/>
      </div>

    </card-with-slidedown>
  </template>
</template>

<script>
import DriverBlock from "@/components/your-profile/bch/drivers/driver-block.vue";
import EmployeeBlock from "@/components/your-profile/bch/employee/employee-block.vue";
import {zeroIfNan} from "@/helpers/utils";

export default {
  name: "profile-blocks",
  components: {EmployeeBlock, DriverBlock},
  props: ['profile', 'product', 'profileComplete'],
  emits: ['add-driver', 'driver-saved', 'driver-deleted', 'employee-saved', 'percentages-updated'],

  data() {
    return {
      employeePercent: 0,
      driverPercents: [],
    };
  },

  computed: {
    driversHeader() {
      return this.product.your_profile_scheme_section_heading;
    },
    driversDescription() {
      return this.product.your_profile_scheme_description;
    },
    driversAveragePercent() {
      if (!this.driverPercents.length) return 100;
      const total = this.driverPercents.reduce((sum, p) => sum + p, 0);
      return Math.round(total / this.driverPercents.length);
    },
    maxAdditionalDrivers() {
      return zeroIfNan(this.product?.maximum_additional_drivers);
    },
    canAddAdditionalDriver() {
      const current = this.profile?.additionalDrivers?.length ?? 0;
      return current < this.maxAdditionalDrivers;
    },
    sectionPercentages() {
      return [
        {title: 'Employee Details', color: this.employeePercent >= 100 ? '#a0c41c' : '#f69641', percent: this.employeePercent},
        {title: this.driversHeader, color: this.driversAveragePercent >= 100 ? '#a0c41c' : '#f69641', percent: this.driversAveragePercent},
      ];
    },
  },

  watch: {
    sectionPercentages: {
      immediate: true,
      handler(val) {
        this.$emit('percentages-updated', val);
      },
    },
    'profile.additionalDrivers'(drivers) {
      // Trim driverPercents when drivers are removed
      if (drivers && this.driverPercents.length > drivers.length) {
        this.driverPercents.splice(drivers.length);
      }
    },
  },

  methods: {
    onEmployeePercentUpdated(percent) {
      this.employeePercent = percent;
    },
    onDriverPercentUpdated(index, percent) {
      this.$set(this.driverPercents, index, percent);
    },
  },
}
</script>

<style scoped>
.driver-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.driver-list-header h5 {
  margin-bottom: 0;
}

.driver-blocks {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
</style>
